'use client'

import { memo } from 'react'

import ChartCardLoading from '@/components/charts/components/ChartCardLoading'

const ChartTotalBorrowLoading = () => {
  return (
    <ChartCardLoading
      className="gap-lg"
      chartClassName="h-[224px]"
      titleClassName="w-[157px]"
      valueClassName="h-[44px] w-[170px]"
      controls={['h-8 w-[191px]', 'h-8 w-[99px]', 'h-8 w-[103px]']}
      mobileControls={['h-8 w-[94px]', 'h-8 w-[103px]']}
    />
  )
}

export default memo(ChartTotalBorrowLoading)
